import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个套餐类型。
 * @enum
 * @version 1.0.0
 */
enum PackageType
{
    /**
     * 体检。
     * @member
     */
    check = 1,

    /**
     * 口腔
     * @member
     */
    mouth,

    /**
     * 绿色通道
     * @member
     */
    green,

    /**
     * 眼科
     * @member
     */
    eye,

    /**
     * 陪诊
     * @member
     */
    accompany,

    /**
     * 基因
     * @member
     */
    gene
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(PackageType,
{
    check:
    {
        alias: "体检",
        description: ""
    },
    mouth:
    {
        alias: "口腔",
        description: ""
    },
    green:
    {
        alias: "绿色通道",
        description: ""
    },
    eye:
    {
        alias: "眼科",
        description: ""
    },
    accompany:
    {
        alias: "陪诊",
        description: ""
    },
    gene:
    {
        alias: "基因",
        description: ""
    }
});

export default PackageType;
